import { SkillTableCellProps } from "./types";
import { mergeClasses } from "@fluentui/react-components";
import { PopoverView } from "@/components/atoms/popover";
import { SkillList } from "@/components/atoms/skillList";
import { useTableStyle } from "@/components/atoms/customTable";

export const SkillTableCell = (props: SkillTableCellProps) => {
	const tableClasses = useTableStyle();

	return (
		<PopoverView
			positioning={{ position: "below", align: "center" }}
			openOnHover={true}
			classes={{
				trigger: mergeClasses(
					tableClasses.columnCellText,
					tableClasses.supervisorInteractionSkillPopoverTrigger
				),
				content: tableClasses.tooltipContent,
			}}
			trigger={
				<SkillList
					skillList={props.skills}
					containerClass={mergeClasses(
						tableClasses.ellipsis,
						tableClasses.columnCellText
					)}
				/>
			}
			content={
				<SkillList
					skillList={props.skills}
					containerClass={tableClasses.tooltipContentContainer}
					textClass={tableClasses.tooltipText}
				/>
			}
		/>
	);
};
